import ImageUploadWidget from "@flipdish/portal-library/components/organisms/ImageUploadWidget";
import ThemeProvider from '@flipdish/portal-library/themes/ThemeProvider';
import { connect } from "react-redux";

const imageUtil = require('../../utils/image/imageUtil');
const viewUtil = require('../../utils/view/viewUtil');

function ImageUpload({imageUploadArgs}) {
    const {
        title = 'Upload Image',
        imageUrl,
        imageCategory,
        onClose = () => {},
        onRemove,
        onUpload,
    } = imageUploadArgs;

    const isCloudinaryAsset = !imageUtil.isImgixAsset(imageUrl);
    const cdnCloudName = imageUtil.getCloudinaryUsersCloudName();

    const handleClose = () => {
        onClose();
        viewUtil.closeImageUploadDialogue();
    }

    const handleRemove = () => {
        viewUtil.removeUploadImage();
        onRemove && onRemove();
    }

    const handleFileUpload = async (imgFile) => {
        try {
            const uploadedImgUrl = await imageUtil.uploadImageFile(imgFile, imageCategory);
            onUpload(uploadedImgUrl);
            viewUtil.updateUploadImage(uploadedImgUrl);
        } catch (error) {
            viewUtil.showErrorAlert(`Error occurred while uploading image: ${error}`,);
        }
    }

    const handleLinkUpload = async (imgLink) => {
        try {
            const uploadedImgUrl = await imageUtil.uploadImageLink(imgLink, imageCategory);
            onUpload(uploadedImgUrl);
            viewUtil.updateUploadImage(uploadedImgUrl);
        } catch (error) {
            viewUtil.showErrorAlert(`Error occurred while uploading image: ${error}`);
        }
    }

    return (
        <ThemeProvider>
            <ImageUploadWidget
                open={!!imageUploadArgs}
                widgetTitle={title}
                imageUrl={imageUrl}
                isCloudinaryAsset={isCloudinaryAsset}
                cdnCloudName={cdnCloudName}
                onClose={handleClose}
                onRemove={handleRemove}
                onUpload={handleFileUpload}
                onUploadImageLink={handleLinkUpload}
            />
        </ThemeProvider>
    );
}

const mapStateToProps = (state) => ({
    imageUploadArgs: state.imageUploadDialogue,
});

export default connect(mapStateToProps)(ImageUpload);